import { render, staticRenderFns } from "./NewProductOrService.vue?vue&type=template&id=2c2c3c62&scoped=true"
import script from "./NewProductOrService.vue?vue&type=script&lang=js"
export * from "./NewProductOrService.vue?vue&type=script&lang=js"
import style0 from "./NewProductOrService.vue?vue&type=style&index=0&id=2c2c3c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2c3c62",
  null
  
)

export default component.exports